var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2059 7.5C66.2059 3.35787 62.848 0 58.7059 0C54.5638 0 51.2059 3.35786 51.2059 7.5V49.3103L7.5 49.3103C3.35786 49.3103 0 52.6682 0 56.8103C0 60.9525 3.35786 64.3103 7.5 64.3103H51.2059V108.19C51.2059 112.332 54.5638 115.69 58.7059 115.69C62.848 115.69 66.2059 112.332 66.2059 108.19V64.3103H108.19C112.332 64.3103 115.69 60.9525 115.69 56.8103C115.69 52.6682 112.332 49.3103 108.19 49.3103L66.2059 49.3103V7.5Z",
    fill: "#e8e8e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlus);
export default __webpack_public_path__ + "static/media/bigPlus.714bdbf4ff9f317ac90728e07649c58b.svg";
export { ForwardRef as ReactComponent };